// ** React Imports
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

// ** Store & Actions
import { useSelector, useDispatch } from "react-redux";
import {
    handleMenuCollapsed,
    handleContentWidth,
    handleMenuHidden,
} from "@store/layout";

// ** Third Party Components
import classnames from "classnames";
import { ArrowUp } from "react-feather";

// ** Reactstrap Imports
import { Navbar, Button } from "reactstrap";

// ** Configs
import themeConfig from "@configs/themeConfig";

// ** Custom Components
// import Customizer from "@components/customizer";
import ScrollToTop from "@components/scrolltop";
import FooterNavbarComponentComponent from "./components/footer";
import NavbarComponent from "./components/navbar";
import SidebarComponent from "./components/menu/vertical-menu";

// ** Custom Hooks
import { useRTL } from "@hooks/useRTL";
import { useSkin } from "@hooks/useSkin";
import { useNavbarType } from "@hooks/useNavbarType";
import { useFooterType } from "@hooks/useFooterType";
import { useNavbarColor } from "@hooks/useNavbarColor";

// ** Styles
import "@styles/base/core/menu/menu-types/vertical-menu.scss";
import "@styles/base/core/menu/menu-types/vertical-overlay-menu.scss";
import Spinner from "../components/spinner/Fallback-spinner";
import Repository from "../../configs/axios/repository";
import { handleShowMenu, handleLoad } from "../../redux/layout";
import { encrypt } from "../../utility/helpers/encrypt";
const VerticalLayout = (props) => {
    // ** Props
    const {
        menu,
        navbar,
        footer,
        menuData,
        children,
        routerProps,
        currentActiveItem,
    } = props;

    // ** Hooks
    const { skin, setSkin } = useSkin();
    const { navbarType, setNavbarType } = useNavbarType();
    const { footerType, setFooterType } = useFooterType();
    const { navbarColor, setNavbarColor } = useNavbarColor();

    // ** States
    const [isMounted, setIsMounted] = useState(false);
    const [menuVisibility, setMenuVisibility] = useState(false);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    // ** Store Vars
    const dispatch = useDispatch();
    const layoutStore = useSelector((state) => state.layout);

    // ** Update Window Width
    const handleWindowWidth = () => {
        setWindowWidth(window.innerWidth);
    };

    // ** Vars
    const location = useLocation();
    const contentWidth = layoutStore.contentWidth;
    const menuCollapsed = layoutStore.menuCollapsed;
    const isHidden = layoutStore.menuHidden;
    const [loadingData, setLoadingData] = useState(false);
    const [loadSubscription, setLoadSubscription] = useState(false);
    const [spiner, setSpiner] = useState(true);
    // ** Toggles Menu Collapsed
    const setMenuCollapsed = (val) => dispatch(handleMenuCollapsed(val));

    // ** Handles Content Width
    const setContentWidth = (val) => dispatch(handleContentWidth(val));
    const setHandleLoad = (val) => dispatch(handleLoad(val));

    // ** Handles Content Width
    const setIsHidden = (val) => dispatch(handleMenuHidden(val));

    const [planAmount, setPlanAmount] = useState("");
    const [interval, setInterval] = useState("");
    const [currentPeriosEnd, setCurrentPeriosEnd] = useState("");
    const [planType, setPlanType] = useState("");
    const [products, setProducts] = useState([]);
    const [subscriptionUrl, setSubscriptionUrl] = useState("");
    const [subscriptionId, setSubscriptionId] = useState(null);
    let localStor = localStorage.getItem("handleLoad");
    const [trialEnd, setTrialEnd] = useState(null);

    //** This function will detect the Route Change and will hide the menu on menu item click
    useEffect(() => {
        if (menuVisibility && windowWidth < 768) {
            setMenuVisibility(false);
        }
    }, [location]);

    //** Sets Window Size & Layout Props
    useEffect(() => {
        if (window !== undefined) {
            window.addEventListener("resize", handleWindowWidth);
        }
    }, [windowWidth]);

    //** ComponentDidMount
    useEffect(() => {
        setIsMounted(true);
        return () => setIsMounted(false);
    }, []);
    const subscriptionData = (val) => {
        let prodName = "";
        if (planType == "Starter Plan") {
            prodName = "Professional Plan";
        } else if (planType == "Professional Plan") {
            prodName = "Business Plan";
        }
        for (let i = 0; i < products.length; i++) {
            if (products[i].name == prodName) {
                for (let j = 0; j < products[i].prices.length; j++) {
                    if (interval == products[i].prices[j].metadata.Interval) {
                        setSubscriptionUrl(
                            `/subscription/${encrypt(
                                JSON.stringify({
                                    priceId: products[i].prices[j].id,
                                    productId: products[i].id,
                                    btnName: "UPGRADE",
                                })
                            )}`
                        );
                    }
                }
            }
        }
        setLoadSubscription(true);
    };
    useEffect(() => {
        if (planType != "" && products[0]) {
            if (planType == "Business Plan") {
            } else {
                subscriptionData();
            }
        }
    }, [planType, products]);
    // ** Vars
    const footerClasses = {
        static: "footer-static",
        sticky: "footer-fixed",
        hidden: "footer-hidden",
    };

    const navbarWrapperClasses = {
        floating: "navbar-floating",
        sticky: "navbar-sticky",
        static: "navbar-static",
        hidden: "navbar-hidden",
    };

    const navbarClasses = {
        floating:
            contentWidth === "boxed"
                ? "floating-nav container-xxl"
                : "floating-nav",
        sticky: "fixed-top",
        static: "navbar-static-top",
        hidden: "d-none",
    };

    const bgColorCondition =
        navbarColor !== "" &&
        navbarColor !== "light" &&
        navbarColor !== "white";

    if (!isMounted) {
        return null;
    }
    return (
        <div>
            <div
                className={classnames(
                    `children wrapper vertical-layout ${
                        navbarWrapperClasses[navbarType] || "navbar-floating"
                    } ${footerClasses[footerType] || "footer-static"}`,
                    {
                        // Modern Menu
                        "vertical-menu-modern": windowWidth >= 768,
                        "menu-collapsed": menuCollapsed && windowWidth >= 768,
                        "menu-expanded": !menuCollapsed && windowWidth > 768,

                        // Overlay Menu
                        "vertical-overlay-menu": windowWidth < 1200,
                        "menu-hide": !menuVisibility && windowWidth < 768,
                        "menu-open": menuVisibility && windowWidth < 1200,
                    }
                )}
            >
                {" "}
                {children}
            </div>
            <div
                className={classnames(
                    `wrapper vertical-layout ${
                        navbarWrapperClasses[navbarType] || "navbar-floating"
                    } ${footerClasses[footerType] || "footer-static"}`,
                    {
                        // Modern Menu
                        "vertical-menu-modern": windowWidth >= 768,
                        "menu-collapsed": menuCollapsed && windowWidth >= 768,
                        "menu-expanded": !menuCollapsed && windowWidth > 768,

                        // Overlay Menu
                        "vertical-overlay-menu": windowWidth < 1200,
                        "menu-hide": !menuVisibility && windowWidth < 768,
                        "menu-open": menuVisibility && windowWidth < 1200,
                    }
                )}
                {...(isHidden ? { "data-col": "1-column" } : {})}
                onClick={(e) => {
                    dispatch(handleShowMenu(false));
                }}
            >
                {!isHidden ? (
                    <SidebarComponent
                        skin={skin}
                        menu={menu}
                        menuData={menuData}
                        routerProps={routerProps}
                        menuCollapsed={menuCollapsed}
                        menuVisibility={menuVisibility}
                        setMenuCollapsed={setMenuCollapsed}
                        setMenuVisibility={setMenuVisibility}
                        currentActiveItem={currentActiveItem}
                        planAmount={planAmount}
                        currentPeriosEnd={currentPeriosEnd}
                        interval={interval}
                        planType={planType}
                        trialEnd={trialEnd}
                        subscriptionUrl={subscriptionUrl}
                        products={products}
                        subscriptionId={subscriptionId}
                    />
                ) : null}

                <Navbar
                    id="navbar_container"
                    expand="lg"
                    container={false}
                    light={skin !== "dark"}
                    dark={skin === "dark" || bgColorCondition}
                    color={bgColorCondition ? navbarColor : undefined}
                    className={classnames(
                        `header-navbar navbar align-items-center ${
                            navbarClasses[navbarType] || "floating-nav"
                        } navbar-shadow`
                    )}
                    onClick={() => {
                        dispatch(handleShowMenu(false));
                    }}
                >
                    <div className="navbar-container d-flex content">
                        {navbar ? (
                            navbar
                        ) : (
                            // <div></div>
                            <NavbarComponent
                                setMenuVisibility={setMenuVisibility}
                                skin={skin}
                                setSkin={setSkin}
                            />
                        )}
                    </div>
                </Navbar>

                {/* Vertical Nav Menu Overlay */}
                <div
                    className={classnames("sidenav-overlay", {
                        show: menuVisibility,
                    })}
                    onClick={() => {
                        dispatch(handleShowMenu(false));
                        setMenuVisibility(false);
                    }}
                ></div>
            </div>
        </div>
    );
};

export default VerticalLayout;
